import { createSlice } from '@reduxjs/toolkit';
import { IUser } from 'packages/lib-utils';

// Define the TS type for the counter slice's state
export interface UserState {
  user: IUser | null;
  currentApplication: string | null;
}

// Define the initial value for the slice state
const initialState: UserState = {
  user: null,
  currentApplication: null,
};

export const userSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.user = action.payload;
    },
    resetFilter: (state) => {
      state.user = initialState.user;
    },
    setCurrentApplication: (state, action) => {
      state.currentApplication = action.payload;
    },
  },
});

// Export the generated action creators for use in components
export const { setUserInfo, resetFilter, setCurrentApplication } = userSlice.actions;

// Export the slice reducer for use in the store configuration
export default userSlice.reducer;
